module.exports = __webpack_public_path__ + "img/main-belt.fa87887c.jpg";